import { Permission } from '@shared/infrastructure/auth/permission.js';
import type { AppModule } from '@shared/presentation/router/composition.js';
import { VP_SECTION_NAV } from '../presentation/section-nav.js';

/**
 * `engines` feature of Virtual Profiler: the analysis engines' versions and what changed in each.
 *
 * One screen today, the changelog of one engine, reached from the groups board's Motores card. The
 * route takes any engine name, not only the two that card lists: every engine is versioned, and a
 * screen that lists them all will link here as it is.
 *
 * It renders inside the shell, hence `layoutRoutes`. With no `meta.public` the guard protects it,
 * which is the default.
 */
export const virtualProfilerEnginesModule: AppModule = {
  name: 'virtual-profiler-engines',
  routes: [],
  layoutRoutes: [
    {
      path: 'virtual-profiler/engines/:engine/changelog',
      name: 'virtual-profiler-engine-changelog',
      component: () => import('./presentation/EngineChangelogView.vue'),
      // A detail: it slides in over the board it was opened from.
      meta: {
        permission: Permission.VIRTUAL_PROFILER_READ,
        slidesIn: true,
        sectionNav: VP_SECTION_NAV,
      },
    },
  ],
};
